export const defaultCheckinOffset = 7;
export const defaultCheckoutOffset = 8;
